module.exports = __webpack_public_path__ + "img/participant-fields-icon-active.ab141c44.svg";